
import { defineComponent, computed } from 'vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'IntegrationPagination',
  props: {
    currentPage: {
      type: Number,
      required: true,
    },

    totalItems: {
      type: Number,
      required: true,
    },

    rowsPerPage: {
      type: Number,
      required: true,
    },
  },

  emits: ['update:currentPage'],

  setup(props) {
    const { t } = useI18n();

    const totalPages = computed(() => Math.ceil(props.totalItems / props.rowsPerPage));

    const firstItem = computed(() => {
      if (props.totalItems === 0) return 0;
      return (props.currentPage - 1) * props.rowsPerPage + 1;
    });

    const lastItem = computed(() => {
      const last = props.currentPage * props.rowsPerPage;
      return last > props.totalItems ? props.totalItems : last;
    });

    return {
      t,
      totalPages,
      firstItem,
      lastItem,
    };
  },
});
